<template>
  <Button
    class="size-control min-w-control !rounded-l-none !p-0 text-[--v3-button-buttontextcolor]"
    severity="primary"
    :disabled="props.disabled"
    @click="emit('onSearch')"
  >
    <Icon
      class="m-auto"
      name="search"
      :width="24"
      :height="24"
    />
  </Button>
</template>

<script setup lang='ts'>
import Button from 'primevue/button';

import Icon from '@/common/components/atoms/Icon';

const props = defineProps<{
  disabled: boolean;
}>();
const emit = defineEmits<{
  'onSearch': [];
}>();
</script>


